import { Injectable, signal } from '@angular/core';
import { CreditsLogModalComponent } from '../components/credits-log-modal/credits-log-modal.component';

@Injectable({ providedIn: 'root' })
export class CreditsLogModalHostService {
  private readonly modalRef = signal<CreditsLogModalComponent | null>(null);

  /**
   * Registers the app-level credit log modal instance.
   *
   * @param {CreditsLogModalComponent | null} modal Modal to register, or null on destroy.
   * @returns {void}
   */
  register(modal: CreditsLogModalComponent | null): void {
    this.modalRef.set(modal);
  }

  /**
   * Opens the credit log modal.
   *
   * @returns {void}
   * @throws {Error} If the modal is not registered on AppComponent.
   */
  open(): void {
    const modal = this.modalRef();
    if (!modal) {
      throw new Error(
        'CreditsLogModalHostService: modal not registered. Add app-credits-log-modal to AppComponent.',
      );
    }
    modal.open();
  }
}
